import { useState } from 'react';
import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom'

const useVerifySurveyId = () => {
    const [searchParams, setSearchparams] = useSearchParams()
    const [surveyId, setSurveyId] = useState(null)
    const navigate = useNavigate()

    useEffect(() => {
        const survey_id = searchParams.get('survey_id')
        if (survey_id) {
            setSurveyId(survey_id)
        } else {
            navigate('/admin/survey/list')
        }
    }, [searchParams])

    return surveyId
}

export default useVerifySurveyId